import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from './setAxios';
import { formaturl } from '../config/staticData';

function Navbar() {
    const [menus, setMenus] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        (async () => await Load())();
    }, []);

    async function Load() {
        const result = await api.get("/blogStructure/GetMenuStructure");
        setMenus(result.data);
    }

    const toggleMenu = () => {
        setIsOpen(!isOpen); 
    };

    function buildMenuTree(data) {
        const items = {};
        const rootItems = [];

        // ساخت دیکشنری از آیتم‌ها
        data.forEach(item => {
            items[item.id] = { ...item, children: [] };
        });

        // اختصاص دادن زیرمنوها به والدینشان
        data.forEach(item => {
            if (item.parentID) {
                items[item.parentID].children.push(items[item.id]);
            } else {
                rootItems.push(items[item.id]);
            }
        });

        return rootItems;
    }

    const MenuItem = ({ item, isActive }) => {
        const [hover, setHover] = useState(false);

        return (
            <li
                className="menu-item"
                style={{ backgroundColor: isActive ? 'blue' : 'inherit' }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                <Link to={`${process.env.REACT_APP_BASE_PATH}/blogCategory/${item.id}/${formaturl(item.title)}`} >
                    {item.title}
                </Link>
                {hover && item.children.length > 0 && (
                    <ul className="submenu">
                        {item.children.map(child => (
                            <MenuItem key={child.id} item={child} isActive={isActive} />
                        ))}
                    </ul>
                )}
            </li>
        );
    };

    const MenuTree = ({ data, currentPage }) => {
        const treeData = buildMenuTree(data);

        return (
            <ul className={`menu-list ${isOpen ? 'open' : ''}`}>
                <li className="sidebar-logo-mobile" >
                    <img src="images/logo.png" alt="Logo Desktop" />
                </li>
                <li className="menu-item">
                    <Link to={`/blog/`} >
                        خانه
                    </Link>
                </li>
                {treeData.map(item => (
                    <MenuItem key={item.id} item={item} isActive={item.id === currentPage} />
                ))}
            </ul>
        );
    };


  const currentPageId = 10; // ID صفحه‌ای که فعال است

  return (
      <>
          <nav className='category-navbar'>
              <button onClick={toggleMenu} className="menu-toggle">
                  <i id="bar" className={isOpen ? "fas fa-times" : "fa fa-bars"}></i>
              </button>
              <Link to='https://www.toorangco.com' target='_blank' className="category-menu-logo">
                  <img  src="images/logo-mobile.png" alt='فروشگاه آنلاین تورنگ' />
              </Link>
              <Link to={`${process.env.REACT_APP_BASE_PATH}/search`} className="mobile-search" >
                  <i className="fa fa-search" aria-hidden="true"></i>
              </Link>
              {isOpen && (
                  <button onClick={toggleMenu} className="close-menu">
                      <i className="fas fa-times"></i>
                  </button>
              )}
              <MenuTree data={menus} currentPage={currentPageId} />
          </nav>
      </>
  );
}

export default Navbar;